// React / Gatsby --------------------------------------------------
import React from 'react';
import { graphql } from 'gatsby'

// Plugins ---------------------------------------------------------


// Layout ----------------------------------------------------------
import { Layout } from '../components/layout'

// Data Hooks ------------------------------------------------------
import * as Context from '../components/context'
import { useChapterData } from '../hooks/chapter_data'
import ReactMarkdown from 'react-markdown'

// Components ------------------------------------------------------
import { CoverImage } from '../components/images'
import { Banner, BannerContent } from '../components/banner'
import { TitleRacism } from '../components/titles/racism'
import { Slide, ContentContainer, Paragraph } from '../components/slide'
import { ChapterNavigation } from '../components/chapter_navigation';

// Chapter Function ------------------------------------------------
export default function Chapter08({data}) {
	const chapterData = useChapterData()
	const title = chapterData.chapter8.chapter_title
	const number = chapterData.chapter8.chapter_number

	return (
		<Context.Template.Provider
			value={{
				pageTitle: title,
				number: number,
				pageID: `chapter-${number}`,
				footerTheme: "light",
				navTheme: "ghostBlack",
			}}
		>
			<Layout>
				<Banner quote="kendi" caption={true} captionTheme="light">
					<BannerContent arrowTheme="dimdark" arrowPos="right">
						<TitleRacism />
					</BannerContent>
					<CoverImage
						imgSrc={data.coverImage.childImageSharp.fluid}
						screen={false}
						imgTag="teach_cover"
						imgFit="cover"
						objectPosition="30% 50%"
					/>
				</Banner>
				<Slide theme="light">
					<ContentContainer transition="fadeUp">
						<Paragraph direction='down'>
							<ReactMarkdown linkTarget="_blank">
								{
									chapterData.chapter8.text_block[0]
										.text_block_editor
								}
							</ReactMarkdown>
						</Paragraph>
						<Paragraph direction='down'>
							<ReactMarkdown linkTarget="_blank">
								{
									chapterData.chapter8.text_block[1]
										.text_block_editor
								}
							</ReactMarkdown>
						</Paragraph>
						<Paragraph direction='down'>
							<ReactMarkdown linkTarget="_blank">
								{
									chapterData.chapter8.text_block[2]
										.text_block_editor
								}
							</ReactMarkdown>
						</Paragraph>
					</ContentContainer>
				</Slide>
				<ChapterNavigation
					index={number}
					prevPos="45% 50%"
					nextPos="40% 50%"
				/>
			</Layout>
		</Context.Template.Provider>
	)
}

//Image Queries ------------------------------------------------------
export const queryCover = graphql`
  {
    coverImage: file(relativePath: {eq: "covers/kendi.jpg"}) {
      id
      childImageSharp {
        fluid(maxWidth: 2000, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
